import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={394.099}
      height={334.946}
      viewBox="0 0 394.099 334.946"
      {...props}
    >
      <defs>
        <linearGradient
          id="prefix__a"
          x1={0.5}
          y1={-0.197}
          x2={0.5}
          y2={0.899}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#d6f5f8" />
          <stop offset={1} stopColor="#6ce4f2" />
        </linearGradient>
        <linearGradient
          id="prefix__b"
          x1={0.5}
          y1={0.126}
          x2={0.5}
          y2={0.873}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#fbe496" />
          <stop offset={1} stopColor="#ff8e01" />
        </linearGradient>
        <linearGradient
          id="prefix__d"
          x1={0.463}
          y1={0.047}
          x2={0.549}
          y2={1.098}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#f9ff67" />
          <stop offset={1} stopColor="#baa800" />
        </linearGradient>
        <linearGradient
          id="prefix__f"
          x1={0.035}
          y1={0.044}
          x2={1.234}
          y2={1.059}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#f8fc5e" />
          <stop offset={1} stopColor="#86ae00" />
        </linearGradient>
        <linearGradient
          id="prefix__j"
          x1={0.745}
          y1={-0.027}
          x2={0.232}
          y2={1.27}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#f1eb58" />
          <stop offset={1} stopColor="#baae02" />
        </linearGradient>
        <linearGradient
          id="prefix__l"
          x1={1.043}
          y1={-0.644}
          x2={-0.097}
          y2={1.527}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#86b004" />
          <stop offset={1} stopColor="#d2e23a" />
        </linearGradient>
        <clipPath id="prefix__c">
          <path
            data-name="Path 11111"
            d="M50.247 316.067c2.2-4.8 4.523-9.7 5.142-14.947a17.6 17.6 0 00-3.789-12.985c-3.1-3.809-7.713-6.179-10.711-10.066a16.742 16.742 0 01-1.743-17.178c2.371-4.863 8.558-8.471 13.256-5.8 4.358 2.493 4.9 8.532 7.7 12.715 3.617 5.4 10.72 7.286 15.252 11.949a16.925 16.925 0 014.346 14.951c-.723 3.538-2.615 6.972-1.978 10.554 1.211 6.746 10.458 9.395 12.271 16 1.159 4.209-1.29 8.715-4.811 11.33s-7.9 3.626-12.2 4.514c-6.963 1.455-15 2.466-20.533-2.031.003.002-8.59-5.079-2.202-19.006z"
            transform="translate(-37.545 -254.185)"
            fill="none"
          />
        </clipPath>
        <clipPath id="prefix__e">
          <path
            data-name="Path 11117"
            d="M34.87 326.105c-2.615-1.377-4.2-4.183-5.308-6.972s-1.821-5.665-3.155-8.314a19.444 19.444 0 00-6.972-7.669c-3.678-2.318-8.035-3.338-11.888-5.421S.21 291.863.576 287.514c.392-4.628 5.229-7.9 9.848-8.157s9.081 1.743 13.221 3.887a175.947 175.947 0 0116.672 9.744 31.689 31.689 0 016.859 5.639c6.1 7.129 5.412 18.3.453 26.241 0 0-6.797 4.34-12.759 1.237z"
            transform="translate(-.55 -279.335)"
            fill="none"
          />
        </clipPath>
        <clipPath id="prefix__g">
          <path
            data-name="Rectangle 1673"
            fill="none"
            d="M0 0h52.012v121.891H0z"
          />
        </clipPath>
        <clipPath id="prefix__h">
          <path
            data-name="Rectangle 1676"
            fill="none"
            d="M0 0h113.96v76.467H0z"
          />
        </clipPath>
        <clipPath id="prefix__i">
          <path
            data-name="Path 11127"
            d="M363.976 316.067c-2.2-4.8-4.532-9.7-5.142-14.947a17.631 17.631 0 013.782-12.986c3.1-3.809 7.713-6.179 10.72-10.066a16.742 16.742 0 001.743-17.178c-2.371-4.863-8.558-8.471-13.265-5.8-4.358 2.493-4.889 8.532-7.687 12.715-3.617 5.4-10.72 7.286-15.252 11.949a16.925 16.925 0 00-4.358 14.947c.723 3.538 2.615 6.972 1.978 10.554-1.211 6.746-10.458 9.395-12.28 16-1.15 4.209 1.3 8.715 4.82 11.33s7.9 3.626 12.2 4.514c6.972 1.464 15.042 2.458 20.55-2.074-.022.05 8.58-5.031 2.191-18.958z"
            transform="translate(-323.931 -254.185)"
            fill="none"
          />
        </clipPath>
        <clipPath id="prefix__k">
          <path
            data-name="Path 11133"
            d="M379.61 326.1c2.615-1.377 4.2-4.183 5.308-6.972s1.813-5.665 3.146-8.314a19.575 19.575 0 016.972-7.669c3.7-2.327 8.062-3.347 11.9-5.43s7.329-5.865 6.972-10.214c-.392-4.628-5.229-7.9-9.839-8.157s-9.081 1.743-13.221 3.887a175.936 175.936 0 00-16.681 9.752 31.741 31.741 0 00-6.868 5.639c-6.1 7.129-5.4 18.3-.444 26.241-.004.003 6.794 4.343 12.755 1.237z"
            transform="translate(-362.926 -279.325)"
            fill="none"
          />
        </clipPath>
      </defs>
      <g data-name="Group 673">
        <g data-name="Asset 43">
          <g data-name="Layer 2">
            <path
              data-name="Path 11096"
              d="M64.805 299.715c-24.24-20.916-88.9-76.057-55.353-118.463 7.661-9.674 23.4-9.343 31.715-18.459 10.458-11.46 5.177-29.44 1.177-44.448-4.872-18.3-6.772-38.112-.078-55.777S65.98 30.2 84.875 30.868c11.112.4 21.335 5.787 31.479 10.371 16.472 7.46 34.312 13.151 52.361 11.922 23.487-1.595 44.814-14.659 68.135-17.953 29.98-4.236 60.911 8.715 82.193 30.25s33.571 50.8 38.591 80.668 3.068 61.416-8.009 89.714-31.575 53.25-58.392 67.517z"
              fill="#b8ebf4"
            />
            <g data-name="Group 565">
              <path
                data-name="Path 11097"
                d="M64.8 304.263C40.56 283.347-24.1 228.206 9.447 185.8c7.661-9.674 23.4-9.343 31.715-18.459 10.458-11.46 5.177-29.44 1.177-44.448-4.872-18.3-6.772-38.112-.078-55.777s23.714-32.368 42.609-31.7c11.112.4 21.335 5.787 31.479 10.371 16.472 7.46 34.312 13.151 52.361 11.922 23.487-1.595 44.814-14.659 68.135-17.953 29.98-4.236 60.911 8.715 82.193 30.25s33.571 50.8 38.591 80.668 3.068 61.416-8.009 89.714-31.575 53.25-58.392 67.517z"
                transform="translate(.005 -4.548)"
                fill="url(#prefix__a)"
              />
            </g>
            <g data-name="Group 566">
              <path
                data-name="Path 11098"
                d="M40.966 304.657c-10.964-.166-36.4 2.676-35.349 7.1 1 4.175 18.86 6.031 25.727 6.4 30.216 1.612 55.62 2.989 85.409 3.791 3.634.1 5.09 3.486 2.222 5.125-2.475 1.438-4.75 4.018-1.865 4.976 13.944 4.645 78.175 2.667 110.761 1.159 39.462-1.83 131.992-6.467 138.981-18.816 2.327-4.114-4.131-7.173-9.587-8.332a161.771 161.771 0 00-39.724-3.443z"
                fill="#b2c8cc"
                opacity={0.6}
              />
            </g>
            <path
              data-name="Rectangle 1657"
              fill="#ffbe60"
              d="M71.644 82.672h230.9v219.841h-230.9z"
            />
            <path
              data-name="Rectangle 1658"
              transform="translate(71.644 82.672)"
              fill="url(#prefix__b)"
              d="M0 0h230.9v219.841H0z"
            />
            <path
              data-name="Rectangle 1659"
              fill="#ffe2bb"
              d="M71.644 286.582h230.9v15.931h-230.9z"
            />
            <path
              data-name="Rectangle 1660"
              fill="#f29d2c"
              d="M71.644 82.672h230.9v67.9h-230.9z"
            />
            <path
              data-name="Path 11099"
              d="M57.394 120.104c-.7 11.661 9.683 21.143 21.622 21.143a21.144 21.144 0 100-42.277c-11.939 0-20.916 9.369-21.622 21.134z"
              fill="#dfdfdf"
            />
            <ellipse
              data-name="Ellipse 585"
              cx={21.622}
              cy={21.143}
              rx={21.622}
              ry={21.143}
              transform="translate(100.63 98.961)"
              fill="#e33b38"
            />
            <ellipse
              data-name="Ellipse 586"
              cx={21.622}
              cy={21.143}
              rx={21.622}
              ry={21.143}
              transform="translate(143.866 98.961)"
              fill="#dfdfdf"
            />
            <ellipse
              data-name="Ellipse 587"
              cx={21.622}
              cy={21.143}
              rx={21.622}
              ry={21.143}
              transform="translate(187.103 98.961)"
              fill="#e33b38"
            />
            <ellipse
              data-name="Ellipse 588"
              cx={21.622}
              cy={21.143}
              rx={21.622}
              ry={21.143}
              transform="translate(230.347 98.961)"
              fill="#dfdfdf"
            />
            <ellipse
              data-name="Ellipse 589"
              cx={21.622}
              cy={21.143}
              rx={21.622}
              ry={21.143}
              transform="translate(273.583 98.961)"
              fill="#e33b38"
            />
            <path
              data-name="Path 11100"
              d="M316.819 120.104H57.394l6.284-38.626h248.61z"
              fill="#f25757"
            />
            <path
              data-name="Path 11101"
              d="M57.394 120.104l6.284-38.626h42.861l-5.909 38.626z"
              fill="#fff"
            />
            <path
              data-name="Path 11102"
              d="M187.111 120.104V81.478h-39.215l-4.026 38.626z"
              fill="#fff"
            />
            <path
              data-name="Path 11103"
              d="M230.347 120.104V81.478h39.218l4.018 38.626z"
              fill="#fff"
            />
            <path
              data-name="Rectangle 1661"
              fill="#e33b38"
              d="M63.199 71.125h249.307v12.611H63.199z"
            />
            <path
              data-name="Rectangle 1662"
              fill="#f95d5d"
              d="M63.199 71.125h249.307v3.216H63.199z"
            />
            <path
              data-name="Rectangle 1663"
              fill="#fff"
              d="M63.199 71.125h249.307v.802H63.199z"
            />
            <path
              data-name="Rectangle 1664"
              fill="#fff"
              d="M176.636 167.105h125.908v96.591H176.636z"
            />
            <path
              data-name="Rectangle 1665"
              fill="#fff"
              d="M91.514 167.105h69.878v130.231H91.514z"
            />
            <g
              data-name="Group 568"
              transform="translate(32.726 221.528)"
              clipPath="url(#prefix__c)"
            >
              <path
                data-name="Path 11104"
                d="M12.702 61.882c2.2-4.8 4.523-9.7 5.142-14.947a17.6 17.6 0 00-3.789-12.985c-3.1-3.809-7.713-6.179-10.711-10.066A16.742 16.742 0 011.601 6.706c2.371-4.863 8.558-8.471 13.256-5.8 4.358 2.493 4.9 8.532 7.7 12.715 3.617 5.4 10.72 7.286 15.252 11.949a16.925 16.925 0 014.346 14.951c-.723 3.538-2.615 6.972-1.978 10.554 1.211 6.746 10.458 9.395 12.271 16 1.159 4.209-1.29 8.715-4.811 11.33s-7.9 3.626-12.2 4.514c-6.963 1.455-15 2.466-20.533-2.031.003.002-8.59-5.079-2.202-19.006z"
                fill="#c7bd3a"
              />
              <g data-name="Group 567">
                <path
                  data-name="Path 11105"
                  d="M50.247 316.067c2.2-4.8 4.523-9.7 5.142-14.947a17.6 17.6 0 00-3.789-12.985c-3.1-3.809-7.713-6.179-10.711-10.066a16.742 16.742 0 01-1.743-17.178c2.371-4.863 8.558-8.471 13.256-5.8 4.358 2.493 4.9 8.532 7.7 12.715 3.617 5.4 10.72 7.286 15.252 11.949a16.925 16.925 0 014.346 14.951c-.723 3.538-2.615 6.972-1.978 10.554 1.211 6.746 10.458 9.395 12.271 16 1.159 4.209-1.29 8.715-4.811 11.33s-7.9 3.626-12.2 4.514c-6.963 1.455-15 2.466-20.533-2.031.003.002-8.59-5.079-2.202-19.006z"
                  transform="translate(-37.545 -254.185)"
                  fill="url(#prefix__d)"
                />
              </g>
              <path
                data-name="Path 11106"
                d="M7.508-1.19c.593 12.2 10.816 20.411 17.579 29.553 3.7 5.011 6.327 10.458 6.467 16.794.07 3.32-.331 6.632-.471 9.953a53.841 53.841 0 00.488 9.979 56.919 56.919 0 002.615 10.659c1.116 3.207 2.449 7.268-.078 10.179-.514.593.349 1.464.872.872a8.48 8.48 0 001.595-7.234c-.584-3.268-2.048-6.345-2.841-9.587a52.659 52.659 0 01-1.438-10.354c-.139-3.486.183-6.885.383-10.328a32.987 32.987 0 00-.593-9.8 28.63 28.63 0 00-3.486-8.053c-3.076-5.107-7.242-9.412-11.016-14-4.4-5.351-8.541-11.5-8.889-18.642 0-.784-1.264-.793-1.229 0z"
                fill="#ada028"
              />
              <path
                data-name="Path 11107"
                d="M-2.967 12.38a51.829 51.829 0 0024.612 11.861c.776.139 1.107-1.046.322-1.185A50.775 50.775 0 01-2.096 11.517c-.593-.523-1.464.349-.872.872z"
                fill="#ada028"
              />
              <path
                data-name="Path 11108"
                d="M24.337 25.731a24.8 24.8 0 00-1.882-16.916c-.357-.706-1.412-.087-1.063.619a23.531 23.531 0 011.743 15.975.619.619 0 001.185.322z"
                fill="#ada028"
              />
              <path
                data-name="Path 11109"
                d="M15.047 49.943c1.02 4.131 3.591 7.574 6.554 10.537 3.434 3.434 7.295 6.467 10.981 9.587.6.505 1.473-.357.872-.872-3.53-3.015-7.2-5.926-10.528-9.168-3.015-2.928-5.674-6.3-6.693-10.458-.192-.767-1.377-.436-1.185.331z"
                fill="#ada028"
              />
              <path
                data-name="Path 11110"
                d="M34.613 73.046c-.279-9.97 9.691-17.43 7.73-27.706-.148-.776-1.333-.453-1.185.322.985 5.125-1.5 10-3.765 14.424-2.074 4.053-4.14 8.288-4.009 12.96a.619.619 0 001.229 0z"
                fill="#ada028"
              />
            </g>
            <g
              data-name="Group 570"
              transform="translate(.484 243.446)"
              clipPath="url(#prefix__e)"
            >
              <path
                data-name="Path 11112"
                d="M34.32 46.77c-2.615-1.377-4.2-4.183-5.308-6.972s-1.821-5.665-3.155-8.314a19.444 19.444 0 00-6.972-7.669c-3.678-2.318-8.035-3.338-11.888-5.421S-.34 12.528.026 8.179C.418 3.551 5.255.279 9.874.022s9.081 1.743 13.221 3.887a175.947 175.947 0 0116.672 9.744 31.689 31.689 0 016.859 5.639c6.1 7.129 5.412 18.3.453 26.241 0 0-6.797 4.34-12.759 1.237z"
                fill="#aac037"
              />
              <g data-name="Group 569">
                <path
                  data-name="Path 11113"
                  d="M34.87 326.105c-2.615-1.377-4.2-4.183-5.308-6.972s-1.821-5.665-3.155-8.314a19.444 19.444 0 00-6.972-7.669c-3.678-2.318-8.035-3.338-11.888-5.421S.21 291.863.576 287.514c.392-4.628 5.229-7.9 9.848-8.157s9.081 1.743 13.221 3.887a175.947 175.947 0 0116.672 9.744 31.689 31.689 0 016.859 5.639c6.1 7.129 5.412 18.3.453 26.241 0 0-6.797 4.34-12.759 1.237z"
                  transform="translate(-.55 -279.335)"
                  fill="url(#prefix__f)"
                />
              </g>
              <path
                data-name="Path 11114"
                d="M.245 4.649c11.424 2.906 22.224 8.219 30.651 16.638 6.746 6.78 11.556 15.156 15.077 23.993 1.821 4.567 3.32 9.247 4.732 13.944a.619.619 0 001.185-.322c-2.615-8.715-5.6-17.43-10.162-25.318a61.172 61.172 0 00-21.291-22.015A73.582 73.582 0 00.584 3.464a.619.619 0 00-.322 1.185z"
                fill="#8f9e1e"
              />
              <path
                data-name="Path 11115"
                d="M30.704 2.637c3.486 6.231 7.73 12.018 10.7 18.52 3.207 7.033 4.2 14.685 4.358 22.346a.305.305 0 10.61 0c-.139-7.5-1.072-15.016-4.114-21.954-2.963-6.789-7.417-12.776-11.007-19.217-.192-.349-.723 0-.532.305z"
                fill="#8f9e1e"
              />
              <path
                data-name="Path 11116"
                d="M14.729 26.726c6.266 1.455 12.663 2.937 18.25 6.266a31.914 31.914 0 016.841 5.682 29.475 29.475 0 006.1 5.412.309.309 0 00.314-.532c-2.527-1.516-4.445-3.721-6.449-5.831a30.5 30.5 0 00-6.807-5.456c-5.56-3.225-11.87-4.7-18.075-6.1-.383-.087-.549.505-.157.593z"
                fill="#8f9e1e"
              />
            </g>
            <path
              data-name="Path 11118"
              d="M38.561 273.544c5.952 8.89 9.534 18.956 12.593 29.126a.619.619 0 001.182-.323c-3.085-10.275-6.711-20.455-12.715-29.422-.436-.654-1.5 0-1.063.619z"
              fill="#8f9e1e"
            />
            <path
              data-name="Rectangle 1666"
              fill="#054651"
              d="M96.892 172.657h58.679v124.68H96.892z"
            />
            <path
              data-name="Rectangle 1667"
              fill="#054651"
              d="M182.614 173.476h119.939v84.825H182.614z"
            />
            <path
              data-name="Rectangle 1668"
              fill="#d87c0e"
              d="M176.636 263.687h125.908v7.757H176.636z"
            />
            <path
              data-name="Path 11143"
              d="M188.584 173.476h113.96v76.467h-113.96z"
              fill="#c3f6fa"
            />
            <path
              data-name="Rectangle 1670"
              fill="#c3f6fa"
              d="M103.559 172.657h52.012v121.891h-52.012z"
            />
            <g
              data-name="Group 571"
              transform="translate(103.559 172.657)"
              clipPath="url(#prefix__g)"
              fill="#329bad"
            >
              <path
                data-name="Rectangle 1671"
                d="M39.094-16.745L57.028-4.281l-68.893 99.125L-29.8 82.379z"
              />
              <path
                data-name="Rectangle 1672"
                d="M62.221.816l4.359 3.03-68.893 99.124-4.36-3.03z"
              />
            </g>
            <g
              data-name="Group 572"
              transform="translate(188.584 173.476)"
              clipPath="url(#prefix__h)"
              fill="#329bad"
            >
              <path
                data-name="Rectangle 1674"
                d="M67.239-15.352L85.173-2.888 16.28 96.237-1.654 83.772z"
              />
              <path
                data-name="Rectangle 1675"
                d="M105.987-15.354l4.359 3.03L41.453 86.8l-4.36-3.03z"
              />
            </g>
            <path
              data-name="Path 11119"
              d="M63.199 83.736h249.307S264.25 98.556 182.65 98.97 63.199 83.736 63.199 83.736z"
              fill="#feb0b0"
            />
            <g
              data-name="Group 574"
              transform="translate(282.317 221.528)"
              clipPath="url(#prefix__i)"
            >
              <path
                data-name="Path 11120"
                d="M40.045 61.882c-2.2-4.8-4.532-9.7-5.142-14.947a17.631 17.631 0 013.782-12.986c3.1-3.809 7.713-6.179 10.72-10.066a16.742 16.742 0 001.743-17.178c-2.371-4.863-8.558-8.471-13.265-5.8-4.358 2.493-4.889 8.532-7.687 12.715-3.617 5.4-10.72 7.286-15.252 11.949a16.925 16.925 0 00-4.358 14.947c.723 3.538 2.615 6.972 1.978 10.554-1.211 6.746-10.458 9.395-12.28 16-1.15 4.209 1.3 8.715 4.82 11.33s7.9 3.626 12.2 4.514c6.972 1.464 15.042 2.458 20.55-2.074-.022.05 8.58-5.031 2.191-18.958z"
                fill="#c7bd3a"
              />
              <g data-name="Group 573">
                <path
                  data-name="Path 11121"
                  d="M363.976 316.067c-2.2-4.8-4.532-9.7-5.142-14.947a17.631 17.631 0 013.782-12.986c3.1-3.809 7.713-6.179 10.72-10.066a16.742 16.742 0 001.743-17.178c-2.371-4.863-8.558-8.471-13.265-5.8-4.358 2.493-4.889 8.532-7.687 12.715-3.617 5.4-10.72 7.286-15.252 11.949a16.925 16.925 0 00-4.358 14.947c.723 3.538 2.615 6.972 1.978 10.554-1.211 6.746-10.458 9.395-12.28 16-1.15 4.209 1.3 8.715 4.82 11.33s7.9 3.626 12.2 4.514c6.972 1.464 15.042 2.458 20.55-2.074-.022.05 8.58-5.031 2.191-18.958z"
                  transform="translate(-323.931 -254.185)"
                  fill="url(#prefix__j)"
                />
              </g>
              <path
                data-name="Path 11122"
                d="M44.002-1.19c-.6 12.672-12.053 20.969-18.651 30.686a33.4 33.4 0 00-3.983 7.643 26.642 26.642 0 00-1.4 9.465c.052 3.486.488 6.894.523 10.354a52.388 52.388 0 01-.941 10.458 51.313 51.313 0 01-1.386 5.56c-.54 1.743-1.246 3.486-1.743 5.273-.784 2.928-.784 6.17 1.3 8.567.523.6 1.386-.27.872-.872-2.231-2.562-1.438-6.153-.471-9.064a71.314 71.314 0 002.615-9.351 53.583 53.583 0 00.941-9.935c0-3.32-.383-6.624-.5-9.935a27.261 27.261 0 011.211-9.848 32.465 32.465 0 013.983-7.678c3.364-4.959 7.635-9.212 11.286-13.944 3.913-5.064 7.216-10.816 7.53-17.352.044-.793-1.185-.784-1.229 0z"
                fill="#ada028"
              />
              <path
                data-name="Path 11123"
                d="M54.844 11.517a50.766 50.766 0 01-24.071 11.5c-.776.139-.444 1.325.331 1.185a51.8 51.8 0 0024.6-11.818c.6-.514-.27-1.386-.871-.872z"
                fill="#ada028"
              />
              <path
                data-name="Path 11124"
                d="M29.596 25.409a23.531 23.531 0 011.743-15.975c.349-.706-.706-1.325-1.063-.619a24.8 24.8 0 00-1.882 16.916.619.619 0 001.185-.322z"
                fill="#ada028"
              />
              <path
                data-name="Path 11125"
                d="M36.516 49.611c-1.02 4.148-3.687 7.521-6.693 10.458-3.329 3.242-6.972 6.153-10.528 9.168-.61.514.27 1.377.872.872 3.7-3.155 7.547-6.188 10.99-9.587 2.963-2.963 5.534-6.406 6.554-10.537.192-.767-.994-1.1-1.185-.331z"
                fill="#ada028"
              />
              <path
                data-name="Path 11126"
                d="M19.365 73.046c.131-4.671-1.935-8.907-4.009-12.96-2.266-4.427-4.75-9.3-3.774-14.424.148-.776-1.037-1.107-1.185-.322-1.952 10.24 8.018 17.735 7.739 27.706a.619.619 0 001.229 0z"
                fill="#ada028"
              />
            </g>
            <g
              data-name="Group 576"
              transform="translate(316.302 243.437)"
              clipPath="url(#prefix__k)"
            >
              <path
                data-name="Path 11128"
                d="M16.684 46.775c2.615-1.377 4.2-4.183 5.308-6.972s1.813-5.665 3.146-8.314a19.575 19.575 0 016.972-7.669c3.7-2.327 8.062-3.347 11.9-5.43s7.329-5.865 6.972-10.214c-.392-4.628-5.229-7.9-9.839-8.157s-9.081 1.743-13.221 3.887a175.936 175.936 0 00-16.681 9.752 31.741 31.741 0 00-6.868 5.639c-6.1 7.129-5.4 18.3-.444 26.241-.004.003 6.794 4.343 12.755 1.237z"
                fill="#aac037"
              />
              <g data-name="Group 575">
                <path
                  data-name="Path 11129"
                  d="M379.61 326.1c2.615-1.377 4.2-4.183 5.308-6.972s1.813-5.665 3.146-8.314a19.575 19.575 0 016.972-7.669c3.7-2.327 8.062-3.347 11.9-5.43s7.329-5.865 6.972-10.214c-.392-4.628-5.229-7.9-9.839-8.157s-9.081 1.743-13.221 3.887a175.936 175.936 0 00-16.681 9.752 31.741 31.741 0 00-6.868 5.639c-6.1 7.129-5.4 18.3-.444 26.241-.004.003 6.794 4.343 12.755 1.237z"
                  transform="translate(-362.926 -279.325)"
                  fill="url(#prefix__l)"
                />
              </g>
              <path
                data-name="Path 11130"
                d="M50.439 3.473C38.9 6.445 27.971 11.779 19.465 20.241c-6.92 6.885-11.835 15.391-15.452 24.4C2.131 49.312.597 54.097-.85 58.916a.619.619 0 001.185.322c2.562-8.541 5.464-17.038 9.909-24.812a60.135 60.135 0 0120.829-21.7 72.534 72.534 0 0119.688-8.063.619.619 0 00-.322-1.185z"
                fill="#8f9e1e"
              />
              <path
                data-name="Path 11131"
                d="M19.77 2.332c-3.6 6.441-8.044 12.428-11.016 19.217-3.033 6.972-3.974 14.45-4.1 21.954a.305.305 0 00.61 0c.139-7.661 1.133-15.313 4.358-22.346 2.963-6.5 7.225-12.288 10.7-18.52.192-.34-.34-.654-.532-.305z"
                fill="#8f9e1e"
              />
              <path
                data-name="Path 11132"
                d="M36.111 26.15c-6.2 1.438-12.515 2.911-18.067 6.1a30.112 30.112 0 00-6.685 5.325c-2.048 2.144-4 4.419-6.571 5.961a.307.307 0 10.305.532 29.265 29.265 0 006.1-5.412 31.7 31.7 0 016.841-5.682c5.586-3.329 11.983-4.811 18.25-6.266.383-.087.227-.68-.166-.593z"
                fill="#8f9e1e"
              />
            </g>
            <path
              data-name="Path 11134"
              d="M328.167 272.925c-6 8.968-9.63 19.173-12.715 29.423a.619.619 0 001.185.322c3.05-10.171 6.641-20.237 12.585-29.126.444-.654-.62-1.273-1.055-.619z"
              fill="#8f9e1e"
            />
            <path
              data-name="Rectangle 1677"
              fill="#282f39"
              d="M36.303 297.336h301.581v10.354H36.303z"
            />
            <path
              data-name="Rectangle 1678"
              fill="#4d555e"
              d="M36.303 297.336h301.581v3.32H36.303z"
            />
            <path
              data-name="Path 11135"
              d="M321.29 164.413c-2.327-1.159-4.732-2.388-6.388-4.4s-2.327-5.072-.872-7.242c1.185-1.8 3.486-2.545 5.6-2.832a21.727 21.727 0 0115.347 3.791 26.9 26.9 0 019.883-23.871c3.373-2.615 7.539-4.48 11.827-4.358s8.637 2.405 10.511 6.266a16.481 16.481 0 011.194 7.983 49.257 49.257 0 01-3.286 15.687c9.761-2.615 26.2-4.192 28.76 5.6 5.142 19.723-78.167 29.945-83.343 12.114-1.373-4.703 10.767-8.738 10.767-8.738z"
              fill="#f1f9fb"
            />
            <path
              data-name="Path 11136"
              d="M16.25 200.45a12.785 12.785 0 01-4.358-3.024 4.359 4.359 0 01-.619-4.976 5.342 5.342 0 013.852-1.943 14.9 14.9 0 0110.537 2.615 18.45 18.45 0 016.8-16.385 12.907 12.907 0 018.114-3.007 8.245 8.245 0 017.216 4.305 11.478 11.478 0 01.872 5.482 34.181 34.181 0 01-2.266 10.781c6.7-1.83 17.988-2.876 19.74 3.843 3.538 13.535-53.659 20.55-57.215 8.314-1.013-3.242 7.327-6.005 7.327-6.005z"
              fill="#f1f9fb"
            />
            <path
              data-name="Path 11137"
              d="M277.287 47.062a11.173 11.173 0 01-3.852-2.615 3.826 3.826 0 01-.54-4.358 4.663 4.663 0 013.382-1.743 13.134 13.134 0 019.256 2.283 16.2 16.2 0 015.962-14.387 11.4 11.4 0 017.138-2.615 7.251 7.251 0 016.327 3.782 10 10 0 01.723 4.811 29.84 29.84 0 01-1.978 9.465c5.883-1.6 15.792-2.519 17.335 3.382 3.094 11.888-47.132 18.049-50.252 7.3-.822-2.856 6.499-5.305 6.499-5.305z"
              fill="#b8ebf4"
            />
            <path
              data-name="Path 11138"
              d="M328.001 166.53a14.493 14.493 0 01-5-3.486c-1.29-1.577-1.822-3.965-.7-5.674a6.057 6.057 0 014.358-2.214 17 17 0 0112.027 2.972 21.056 21.056 0 017.774-18.685 14.755 14.755 0 019.273-3.434 9.415 9.415 0 018.227 4.907 13.073 13.073 0 01.933 6.258 38.635 38.635 0 01-2.571 12.315c7.643-2.083 20.516-3.277 22.52 4.358 4.026 15.443-61.224 23.453-65.277 9.491-1.072-3.645 8.436-6.808 8.436-6.808z"
              fill="#b8ebf4"
            />
            <path
              data-name="Path 11139"
              d="M30.508 16.158a7.757 7.757 0 01-2.615-1.83 2.615 2.615 0 01-.418-3 3.216 3.216 0 012.327-1.177 9.038 9.038 0 016.373 1.58 11.147 11.147 0 014.1-9.909A7.844 7.844 0 0145.184 0a4.985 4.985 0 014.358 2.615 6.763 6.763 0 01.5 3.312 20.577 20.577 0 01-1.36 6.51c4.044-1.1 10.868-1.743 11.931 2.327 2.141 8.166-32.438 12.41-34.585 5.011-.566-1.944 4.48-3.617 4.48-3.617z"
              fill="#b8ebf4"
            />
            <path
              data-name="Rectangle 1680"
              fill="#f29d2c"
              d="M267.239 153.919h27.967v9.805h-27.967z"
            />
            <path
              data-name="Rectangle 1681"
              fill="#f29d2c"
              d="M76.542 154.233h27.967v9.805H76.542z"
            />
            <path
              data-name="Rectangle 1682"
              fill="#f29d2c"
              d="M241.878 155.95h14.206v6.371h-14.206z"
            />
            <path
              data-name="Rectangle 1683"
              fill="#d87c0e"
              d="M167.406 275.827h14.206v6.371h-14.206z"
            />
            <path
              data-name="Rectangle 1684"
              fill="#d87c0e"
              d="M207.461 275.827h14.206v6.371h-14.206z"
            />
            <path
              data-name="Rectangle 1685"
              fill="#fff"
              d="M64.478 36.229h248v31.044h-248z"
            />
            <path
              data-name="Path 11142"
              d="M312.506 68.58H63.198V34.922h249.308zM69.498 65.966h236.707V37.537H69.498z"
              fill="#329bad"
            />
            <text
              data-name="\u0628\u0631\u0646\u062F \u0634\u0627\u067E"
              transform="translate(148.966 57.58)"
              fill="#054651"
              fontSize={20}
              fontFamily="IRANYekan-Bold, IRANYekan"
              fontWeight={700}
              letterSpacing=".016em"
            >
             <tspan x={19.226} y={0}>
                 {"برند شاپ"}
             </tspan>
            </text>
          </g>
        </g>
        <g data-name="Layer 2">
          <g data-name="Capa 1">
            <path
              data-name="Path 11055"
              d="M237.241 185.78a.775.775 0 00.775.775.775.775 0 00.775-.775v-3.575a.775.775 0 00-.775-.775.775.775 0 00-.775.775z"
              fill="#f9b233"
            />
            <path
              data-name="Path 11056"
              d="M255.165 203.187a.771.771 0 00-.771.771.775.775 0 00.771.775h3.571a.775.775 0 00.775-.775.775.775 0 00-.775-.771z"
              fill="#f9b233"
            />
            <path
              data-name="Path 11057"
              d="M253.605 194.81a.775.775 0 00-.225 1.071.775.775 0 001.071.225l3-1.953a.775.775 0 00.225-1.071.775.775 0 00-1.071-.229z"
              fill="#f9b233"
            />
            <path
              data-name="Path 11058"
              d="M222.58 194.81a.771.771 0 01.225 1.071.775.775 0 01-1.071.225l-3-1.953a.778.778 0 01-.225-1.071.775.775 0 011.071-.229z"
              fill="#f9b233"
            />
            <path
              data-name="Path 11059"
              d="M246.107 187.116a.775.775 0 000 1.1.768.768 0 001.093 0l2.517-2.532a.768.768 0 000-1.093.775.775 0 00-1.1 0z"
              fill="#f9b233"
            />
            <path
              data-name="Path 11060"
              d="M228.872 188.212a.775.775 0 001.1 0 .775.775 0 000-1.1l-2.532-2.528a.768.768 0 00-1.093 0 .768.768 0 000 1.093z"
              fill="#f9b233"
            />
            <path
              data-name="Path 11061"
              d="M217.285 203.187a.775.775 0 00-.775.771.775.775 0 00.775.775h3.57a.775.775 0 00.775-.775.775.775 0 00-.775-.771z"
              fill="#f9b233"
            />
            <path
              data-name="Path 11062"
              d="M242.982 223.736l-.539 5.245-9.526-.721-.475-5.238z"
              fill="#575756"
            />
            <path
              data-name="Path 11063"
              d="M231.949 223.804a.45.45 0 00.418.478l10.59.714a.45.45 0 00.478-.421.45.45 0 00-.418-.478l-10.586-.715a.453.453 0 00-.482.422z"
              fill="#373636"
            />
            <path
              data-name="Path 11064"
              d="M237.705 188.048a15.029 15.029 0 017.013 28.329 14.529 14.529 0 00-1.735 7.359l-10.54-.714a14.368 14.368 0 00-1.728-6.645 15.029 15.029 0 017.005-28.329z"
              fill="#fee543"
            />
            <path
              data-name="Path 11065"
              d="M231.949 224.925a.45.45 0 00.418.489l10.59.714a.45.45 0 00.478-.421.45.45 0 00-.418-.482l-10.586-.713a.45.45 0 00-.482.418z"
              fill="#373636"
            />
            <path
              data-name="Path 11066"
              d="M231.949 226.1a.45.45 0 00.418.478l10.59.714a.45.45 0 00.478-.418.45.45 0 00-.418-.482l-10.586-.714a.453.453 0 00-.482.422z"
              fill="#373636"
            />
            <path
              data-name="Path 11067"
              d="M231.949 227.274a.45.45 0 00.418.478l10.59.714a.45.45 0 00.478-.421.45.45 0 00-.418-.489l-10.586-.714a.453.453 0 00-.482.421z"
              fill="#373636"
            />
            <path
              data-name="Path 11068"
              d="M232.935 228.27l9.526.714-1.735 2.707h-.564a2.257 2.257 0 01-4.306 0h-.636z"
              fill="#373636"
            />
            <path
              data-name="Path 11069"
              d="M237.705 188.048a15.121 15.121 0 013.214.357 11.029 11.029 0 00-2.174.321 11.537 11.537 0 00-7.441 6.3c-2.885 6.1-1.546 15 4.52 18.717a14.854 14.854 0 0010.515 1.645 15.18 15.18 0 01-1.621.989 14.529 14.529 0 00-1.735 7.359l-10.54-.714a14.368 14.368 0 00-1.728-6.645 15.029 15.029 0 017.005-28.329z"
              fill="#ffd200"
            />
            <path
              data-name="Path 11070"
              d="M240.366 223.45l1.525-13.986c.125-1.093.328-4.47 1.982-4.488 1.553-.018 1.646 2.164.179 2.6-.571.168-1.453-.357-1.832-.236-.714.257-1.642-.5-1.864-1.246-.289-.978.639-1.532.9-.382.461 2.057-3.071 1.785-2.621.046.082-.321.436-.768.746-.564.464.311.311 1.268 0 1.6a1.428 1.428 0 01-1.671.179c-.5-.286-1.028-1.26-.357-1.682.714-.464 1.193 1.632-.189 1.785-.618.071-2.307-.45-1.657-1.378s.957.418.553.939a1.753 1.753 0 01-1.785.421 1.128 1.128 0 01-.686-1.4.611.611 0 011.032-.182c.389.464-.039 1.221-.443 1.532a1.889 1.889 0 01-.9.378 3.209 3.209 0 01-2.142-.225c-1.75-1.025-.557-3.042.939-1.739 1.914 1.685 1.66 5.474 2 7.784l.888 10.07"
              fill="none"
              stroke="#fff"
              strokeMiterlimit={10}
              strokeWidth={0.88}
            />
            <path
              data-name="Path 11071"
              d="M241.779 223.654a14.532 14.532 0 011.728-7.277 15.029 15.029 0 00-6.402-28.315h.6a15.029 15.029 0 017.013 28.315 14.529 14.529 0 00-1.735 7.359z"
              fill="#ffd631"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

const MemoSvgComponent = React.memo(SvgComponent)
export default MemoSvgComponent
